import React from 'react';

const ClubInfo =({ description }) => {
    return (
        <div className={`info`}>
            { description }
        </div>
    );
};

export default ClubInfo;
